<template>
    <div class="login--container">
        <el-card>
            <div class="login--header">
                <a href="index.html" class="logo">
                    <img src="/static/logo_color.png" />
                </a>
                <el-button-group class="btn--group">
                    <g-signin-button
                        class="g-signin2"
                        data-theme="white"
                        data-longtitle="true"
                        :params="googleSignInParams"
                        @success="onSignInSuccess"
                        @error="onSignInError"
                    ></g-signin-button>
                    <br />
                    <a
                        class="btn--login el-button el-button--default"
                        href="/login2"
                        >Or use login Grdar</a
                    >
                </el-button-group>
            </div>
        </el-card>
    </div>
</template>
<script>
import { mapGetters, mapState } from "vuex";
import { LOGIN_GOOGLE } from "@/store/actions.type";
export default {
    data() {
        return {
            googleSignInParams: {
                client_id:
                    "79541948737-cofvlcg5coukbvb0hmnet59plai1ogas.apps.googleusercontent.com"
            }
        };
    },
    methods: {
        onSignInSuccess(googleUser) {
            const profile = googleUser.getBasicProfile();
            console.log(googleUser);
            console.log(profile);
            let email = profile.getEmail();
            this.$store
                .dispatch(LOGIN_GOOGLE, { user: email })
                .then(response => this.loginSuccessful(response))
                .catch(error => this.loginFailed(error));
        },
        onSignInError(error) {
            console.log(error);

            this.loginSuccessful(error);
        },
        loginSuccessful(response) {
            console.log(response);
            if (!response.token) {
                this.loginFailed(response);
                return;
            }
            this.$notify({
                title: "Success",
                message: "Login correcto",
                type: "success",
                position: "bottom-right"
            });
            this.error = false;
            localStorage.analiticatoken = response.token;
            this.$router.replace(
                this.$route.query.redirect || { name: "proyectos" }
            );
        },
        loginFailed(request) {
            this.$notify.error({
                title: "Error",
                message: "Usuario o contraseña incorrecta",
                position: "bottom-right"
            });
            this.$store.dispatch("logout");
            delete localStorage.analiticatoken;
        }
    }
};
</script>

<style lang="scss">
@import url("https://fonts.googleapis.com/css?family=Source+Sans+Pro");
.login--container {
    max-width: 450px;
    margin: 0 auto;
    margin-top: 220px;
    /* padding: 42px 48px; */
    background: #fff;
    -webkit-box-shadow: 0 1px 40px 0 rgba(0, 0, 0, 0.3);
    box-shadow: 0 1px 40px 0 rgba(0, 0, 0, 0.3);
    border-radius: 3px;
}
.login--header {
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.btn {
    &--group {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
    }
    &--login {
        height: 36px;
        width: 180px;
        border-radius: 1px;
        box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.25);
        font-size: 13px;
        font-family: Roboto, arial, sans-serif;
        font-weight: 500;
        letter-spacing: 0.21px;
        margin-left: 6px;
        margin-right: 6px;
        vertical-align: top;
        color: #757575;
        display: flex;
        align-items: center;
        justify-content: center;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/Login/LoginGoogle.vue